export default __webpack_public_path__ + "static/media/category.62377f12.png";